import React from 'react';
import LocationsMap from '../components/LocationsMap';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p className="page-hero-subtitle">
            Get in touch to discuss your automation needs
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>
                Ready to automate your manufacturing processes? We'd love to hear 
                from you. Email or call us using the contact information below to discuss your project.
              </p>

              <div className="contact-details">
                <div className="contact-detail-item">
                  <h3>Contact Information</h3>
                  <p><strong>Email:</strong> <a href="mailto:Contact@sce-automated-us.com">Contact@sce-automated-us.com</a></p>
                  <p><strong>Phone (USA):</strong> <a href="tel:+19152162182">915 216 2182</a></p>
                </div>

                <div className="contact-detail-item">
                  <h3>Headquarters</h3>
                  <p><strong>Engineering and Sales Office</strong></p>
                  <p>221 N Kansas St Ste 700</p>
                  <p>El Paso, Texas 79901-1443</p>
                  <p>United States</p>
                </div>

                <div className="contact-detail-item">
                  <h3>Sales & Applications Offices</h3>
                  <p><strong>Milwaukee, Wisconsin, USA</strong></p>
                  <p>Remote sales / applications representative</p>
                  <p style={{marginTop: '15px'}}><strong>Toluca, Mexico</strong></p>
                  <p>Remote sales / applications representative</p>
                </div>

                <div className="contact-detail-item">
                  <h3>Manufacturing Facility</h3>
                  <p><strong>Ciudad Juarez, Chihuahua, Mexico</strong></p>
                  <p>Shop for building machines from scratch</p>
                  <p>Machining and assembly facility</p>
                </div>

                <div className="contact-detail-item">
                  <h3>Regional Coverage</h3>
                  <p>Our representatives at each location can travel within their region to provide fast, on-site support and service.</p>
                  <p style={{marginTop: '10px'}}>Fast response times thanks to our local presence in key regions.</p>
                </div>

                <div className="contact-detail-item">
                  <h3>Business Hours</h3>
                  <p><strong>El Paso, TX Time (Mountain Time)</strong></p>
                  <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
                  <p>Saturday - Sunday: Closed</p>
                </div>

                <div className="contact-detail-item">
                  <h3>Global Service Areas</h3>
                  <p>North America</p>
                  <p>Central & South America</p>
                  <p>Europe</p>
                </div>
              </div>

              <div className="world-map-section">
                <h3>Our Locations</h3>
                <LocationsMap />
                <div className="map-legend">
                  <div className="legend-item">
                    <span className="legend-marker headquarters"></span>
                    <span>Headquarters (El Paso, TX)</span>
                  </div>
                  <div className="legend-item">
                    <span className="legend-marker office"></span>
                    <span>Sales & Applications Offices</span>
                  </div>
                  <div className="legend-item">
                    <span className="legend-marker facility"></span>
                    <span>Manufacturing Facility</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

